import { useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog'
import type { WhatsappCopy } from '@/frontend/features/WhatsappKnowledge/types'

export default function NewAccountDialog({ open, onOpenChange, copy }: { open: boolean; onOpenChange: (open: boolean) => void; copy: WhatsappCopy }) {
  const form = useForm({ account: { name: '' } })
  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader><DialogTitle>{copy.new_account}</DialogTitle></DialogHeader>
      <form onSubmit={(event) => { event.preventDefault(); form.post('/dashboard/evolution_accounts', { onSuccess: () => { form.reset(); onOpenChange(false) } }) }} className="space-y-5">
        <div className="space-y-2"><Label htmlFor="evolution-account-name">{copy.account_name}</Label><Input id="evolution-account-name" value={form.data.account.name} onChange={(event) => form.setData('account', { name: event.target.value })} maxLength={80} required autoFocus autoComplete="off" /></div>
        <DialogFooter><Button type="button" variant="outline" onClick={() => onOpenChange(false)}>{copy.cancel}</Button><Button disabled={form.processing || !form.data.account.name.trim()}>{copy.save}</Button></DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
}
